/* Landing events only. The Shopify Meta app owns PageView and standard checkout events. */
(() => {
  if (window.KiblemMeta) return;
  const config = document.querySelector('script[data-kiblem-meta-pixel]');
  const pixel = config?.dataset.kiblemMetaPixel;
  if (!/^\d{10,20}$/.test(pixel || '') || config.dataset.kiblemMetaPreview === 'true') return;
  let initialized = false;
  const sent = new Set();
  const allowed = () => {
    try {
      const privacy = window.Shopify?.customerPrivacy;
      return privacy?.marketingAllowed?.() === true && privacy.currentVisitorConsent?.().marketing === 'yes';
    } catch { return false; }
  };
  const cookie = (name) => {
    const entry = document.cookie.split('; ').find((part) => part.startsWith(`${name}=`));
    if (!entry) return '';
    try { return decodeURIComponent(entry.slice(name.length + 1)); } catch { return ''; }
  };
  const init = () => {
    if (!allowed()) return false;
    if (!initialized) {
      if (!window.fbq) {
        const queue = function () { queue.callMethod ? queue.callMethod.apply(queue, arguments) : queue.queue.push(arguments); };
        queue.push = queue;
        queue.loaded = true;
        queue.version = '2.0';
        queue.queue = [];
        window.fbq = queue;
        window._fbq = window._fbq || queue;
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.appendChild(script);
      }
      window.fbq('init', pixel);
      initialized = true;
    }
    window.fbq('consent', 'grant');
    return true;
  };
  const track = (name, value, eventId, onceKey = eventId) => {
    try {
      if (!init() || sent.has(onceKey)) return;
      window.fbq('trackSingle', pixel, name, { currency: 'TRY', value }, { eventID: eventId });
      sent.add(onceKey);
    } catch (error) {
      console.warn('Kıblem ölçüm olayı gönderilemedi.', error);
    }
  };
  const context = () => {
    if (!allowed()) return { marketing_consent: false };
    return {
      marketing_consent: true,
      pixel_id: pixel,
      source_url: `${location.origin}${location.pathname}`,
      user_agent: navigator.userAgent.slice(0, 1000),
      fbp: /^fb\.\d+\.\d+\.\d+$/.test(cookie('_fbp')) ? cookie('_fbp').slice(0, 200) : '',
      fbc: /^fb\.\d+\.\d+\.[A-Za-z0-9_-]+$/.test(cookie('_fbc')) ? cookie('_fbc').slice(0, 500) : ''
    };
  };
  const landing = () => track('ViewContent', 4449, `view-${crypto.randomUUID()}`, 'landing');
  document.addEventListener('visitorConsentCollected', () => {
    if (allowed()) landing();
    else if (initialized) window.fbq('consent', 'revoke');
  });
  if (window.Shopify?.customerPrivacy) landing();
  else window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], (error) => { if (!error) landing(); });
  window.KiblemMeta = Object.freeze({ context, track });
})();
